$(function(){
    var jobNom = '';
    jQuery('.btn-job-popup').on('click', function(event){
        event.preventDefault();
        jQuery(this).parents('.wrapper-poste-item').find('.popup-job').fadeIn(400);
        jQuery('body').addClass('hidden-popup');
        jobNom = jQuery(this).parents('.wrapper-poste-item').find('.titre-job').text();
    });
    jQuery('.popup-job .close-popup-icon, .popup-job .backdrop-popup-job').on('click', function(event){
        console.log('hello');
        event.preventDefault();
        jQuery(this).parents('.wrapper-poste-item').find('.popup-job').fadeOut(400);
        jQuery('body').removeClass('hidden-popup');
    });
    jQuery('.btn-popup-jobapplique').on('click',function(event){
        event.preventDefault();
        jQuery('.popup-job-applique:not(.popup-job-applique-spon)').fadeIn(400);
        jQuery(this).parents('.wrapper-poste-item').find('.popup-job').fadeOut(400);
        jQuery('#field_nomjob').val(jobNom);
    });
    jQuery('.btn-spontanee').on('click',function(event){
        event.preventDefault();
        jQuery('.popup-job-applique-spon').fadeIn(400);
        jQuery(this).parents('.wrapper-poste-item').find('.popup-job').fadeOut(400);
        jQuery('#field_nomjob').val(jobNom);
    });
    jQuery('.btn-spontanee').on('click',function(event){
        jQuery('body').addClass('hidden-popup');
        event.preventDefault();
        jQuery('.popup-job-applique-spon').fadeIn(400);
    });
    jQuery('.popup-job-applique .close-popup-icon, .popup-job-applique .backdrop-popup-job').on('click', function(event){
        console.log(jQuery(this).parents('.wrapper-jobs').length);
        event.preventDefault();
        if(jQuery(this).parents('.wrapper-jobs').length != 0){
            console.log('close popup 1');
            jQuery(this).parents('.wrapper-jobs').find('.popup-job-applique').fadeOut(400);
        }
        else{
            console.log('close popup 2');
            jQuery(this).parents('.popup-job-applique').fadeOut(400);
        }
        jQuery('body').removeClass('hidden-popup');
    });
});